<app-form-field #fileFormField type="FILE"
                label="File"
                [settings]="settings.fieldsSettings.file"
                [value]="valuesForInput.file"
                (modelChange)="updateCurrentValue('file',$event)"
                width="400px">
</app-form-field>
